import { useDispatch, useSelector } from "react-redux";
import { Flex } from "antd";
import LPNField from "./Fields/LPN";
import Result from "./Result";
import Button from "../Reusables/Button/Button";
import { reset, setFilters } from "../../store/inventorySlice";
import "../../assets/css/FilterSection/filterSection.css";
import { useState } from "react";
import DynamicDropdown from "./Fields/DynamicDropdown";

const Wrapper = () => {
  const dispatch = useDispatch();
  const { results } = useSelector((state) => state.inventory);

  const [locationValue, setLocationValue] = useState(null);

  const [lpnValue, setLpnValue] = useState(null);

  const [lpnHasSpecicalChar, setLpnHasSpecialChar] = useState(false);

  const [skuValue, setSkuValue] = useState(null);

  const [qualityStatusValue, setQualityStatusValue] = useState(null);

  const handleFilter = () => {
    dispatch(
      setFilters({
        location: locationValue,
        sku: skuValue,
        lpn: lpnValue,
        qualityStatus: qualityStatusValue
      })
    );
    setLpnHasSpecialChar(false);
  };

  const handleReset = () => {
    setLocationValue(null);
    setLpnValue(null);
    setSkuValue(null);
    setQualityStatusValue(null);
    dispatch(reset());
    setLpnHasSpecialChar(false);
  };

  const dropDownFields = [
    {
      label: "Location",
      dataKey: "location",
      value: locationValue,
      setValue: setLocationValue,
      placeholder: "Enter Location"
    },
    {
      label: "Item",
      dataKey: "sku",
      value: skuValue,
      setValue: setSkuValue,
      placeholder: "Enter Item"
    },
    {
      label: "Quality Status",
      dataKey: "qualityStatus",
      value: qualityStatusValue,
      setValue: setQualityStatusValue,
      placeholder: "Enter Status"
    }
  ];

  const enableFilter =
    locationValue || skuValue || lpnValue || qualityStatusValue;

  return (
    <Flex vertical gap="middle" className="filter-section-wrapper">
      <LPNField
        {...{ lpnValue, setLpnValue, lpnHasSpecicalChar, setLpnHasSpecialChar }}
      />
      {dropDownFields.map((config) => (
        <DynamicDropdown key={config.dataKey} {...config} />
      ))}
      <Flex justify="flex-end" gap="middle">
        <div className="btn-container">
          <Button onClick={handleReset} placeholder="Clear" btnClass="btn" />
        </div>
        <div className="btn-container">
          <Button
            onClick={handleFilter}
            placeholder="Filter"
            btnClass={`btn apply-btn ${
              enableFilter ? "" : "apply-btn-disabled"
            }`}
            disabled={!enableFilter}
          />
        </div>
      </Flex>
      <h4 className="results-label">{`Filtered Locations${
        results.length ? ` (${results.length})` : ""
      }`}</h4>
      <Result setLpnHasSpecialChar={setLpnHasSpecialChar} />
    </Flex>
  );
};

export default Wrapper;
